import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import moment from 'moment';

import { Heading, Join, Paragraph, PlainCard, Skeleton } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

import ConversationParty from './ConversationParty';
import { Link } from '@treams/treams-routes';

import useAuthenticatedUser from '../packages/kakapo-ui-application/hooks/useAuthenticatedUser';

export default Skeleton(
	function ConversationCard(props: {
		submission: graphql.EvaluationSubmission;
		showsOwner?: boolean;
	}) {
		const { localize } = useLocalize();
		const { t } = useTranslation();
		const viewer = useAuthenticatedUser();

		return (
			<PlainCard
				to={
					viewer.id === props.submission.employee.user.id
						? `/conversations/${props.submission.id}`
						: `/users/${props.submission.employee.user.id}/conversations/${props.submission.id}`
				}
			>
				<Box py={3}>
					<Paragraph>
						<Join separator=" · ">
							{props.showsOwner && (
								<>
									{t('conversations.outgoing.card.about')}{' '}
									<Link to={`/users/${props.submission.employee.user.id}`}>
										{props.submission.employee.user.firstName}{' '}
										{props.submission.employee.user.lastName}
									</Link>
								</>
							)}
							{t('conversations.incoming.card.createdAt', {
								date: moment(props.submission.createdAt).format('LL'),
							})}
							{t('conversations.incoming.card.dueDateWithTime', {
								date: moment(props.submission.deadline).format('LL'),
								time: moment(props.submission.deadline).format('HH:MM'),
							})}
						</Join>
					</Paragraph>
					<Heading mt={2}>{localize(props.submission.evaluationForm.title).text}</Heading>
					<Flex mt={3}>
						<ConversationParty
							result={props.submission.employee as graphql.EvaluationSubmissionResult}
						/>
						<ConversationParty
							result={props.submission.manager as graphql.EvaluationSubmissionResult}
						/>
					</Flex>
				</Box>
			</PlainCard>
		);
	},
	function ConversationCardSkeleton() {
		return (
			<PlainCard.Skeleton>
				<Box py={3} flexGrow={1} flexShrink={1}>
					<Paragraph.Skeleton lines={1} />
					<Heading.Skeleton mt={2} />
					<Flex mt={3}>
						<ConversationParty.Skeleton />
						<ConversationParty.Skeleton />
					</Flex>
				</Box>
			</PlainCard.Skeleton>
		);
	},
);
